// Meta (Facebook) Pixel — client side. The base code itself is inlined in
// <head> by nuxt.config.js (it inits the pixel and sends the first PageView).
// This plugin sends PageView on every later client-side route change — Nuxt is
// an SPA after hydration, so the base code alone would only count the first
// page — and injects `$fbq(event, params)` into components and the store.
//
// The pixel ID lives in assets/json/config.json (`metaPixel.id`); an empty ID
// or dev mode leaves the base code out, and then `$fbq` is a no-op.
export default ({ app }, inject) => {
  const enabled = typeof window.fbq === "function"

  if (enabled) {
    app.router.afterEach((to, from) => {
      if (from.name && to.fullPath !== from.fullPath) {
        window.fbq("track", "PageView")
      }
    })
  }

  inject("fbq", (event, params = {}) => {
    if (!enabled) return
    try {
      window.fbq("track", event, params)
    } catch (err) {
      // Tracking must never break the shop
    }
  })
}
